import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { defineMessages, injectIntl } from 'react-intl';

import { LogoGovbr } from '../layout';

import styles from './HeaderLogo.module.less';

const messages = defineMessages({
  portal_name: {
    id: 'Portal Gov.br',
    defaultMessage: 'Portal Gov.br',
  },
});

const HeaderLogo = ({ intl, organ, organUrl }) => {
  return (
    <div className="header-logo">
      <a href="https://www.gov.br" className={styles.logo}>
        <LogoGovbr
          title-id="gov-header-logo"
          title={intl.formatMessage(messages.portal_name)}
        />
      </a>
      {organ ? (
        <>
          <span className="br-divider vertical"></span>
          {organUrl ? (
            <UniversalLink href={organUrl} className="header-sign">
              {organ}
            </UniversalLink>
          ) : (
            <div className="header-sign">{organ}</div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default injectIntl(HeaderLogo);
